import JobPreviewBoardingSection from './JobPreviewBoardingSection.component';

export default JobPreviewBoardingSection;